// extracted by mini-css-extract-plugin
export default {"container":"vyapari-bill-print_container__+a5uw","heading":"vyapari-bill-print_heading__4VXDd","constants":"vyapari-bill-print_constants__kChyX"};